import logo from "../assets/logo-powerone-blue.png";
import { cn } from "../lib/utils";

type LogoProps = {
  white?: boolean;
  className?: string;
};

export function Logo({ white = false, className }: LogoProps) {
  return (
    <img
      src={logo}
      alt="Power One Electric"
      className={cn(
        "h-16 w-16 shrink-0 object-contain md:h-20 md:w-20",
        white && "brightness-0 invert",
        className,
      )}
    />
  );
}
